// ** Event Ustawiający Props "selectorKey" w Celu Uzyskania Informacji
// ** o Tym Który Selecktor Jest Aktualnie Otwarty
// ** Informacja Ta Potrzebna Jest w "Lupce" Do Zamykania Odpowiednich Selektorów
export const ACTUAL_OPEN_SELECTOR = "actualOpenSelector";

export const IS_MULTIPLE_SELECTOR_IN_ACCEPT_MODE =
	"isMultipleSelectorInAcceptMode";
